module.exports = __webpack_public_path__ + "img/erreur.f5bada8e.svg";